import { useEffect, useState } from "react";

const navLinks = [
  { id: "home", label: "首页" },
  { id: "hot", label: "热门推荐" },
  { id: "category", label: "作品分类" },
  { id: "gallery", label: "在线浏览" },
  { id: "updates", label: "更新资讯" },
  { id: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="container-x flex items-center justify-between h-[72px]">
        <a
          href="#home"
          className="flex items-center gap-2.5 whitespace-nowrap"
        >
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-ink-bottle-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl tracking-wide ${
              scrolled ? "text-foreground-950" : "text-foreground-950"
            }`}
          >
            同人本子
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#gallery"
            className="px-5 py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            浏览作品
          </a>
          <a
            href="#hot"
            className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            立即查看
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-900"
          aria-label="打开菜单"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={() => setOpen(false)}
                  className="block px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-md whitespace-nowrap"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}